/* src/index.js */

import React from 'react';
import { createRoot } from 'react-dom/client'; // Use createRoot for React 18+
import './index.css'; // Import global styles (including Tailwind)
import App from './App'; // Main application component
import '@fortawesome/fontawesome-free/css/all.min.css';
import { initializeLogInterceptor } from './utils/logInterceptor'; // Import the interceptor
// *** Import the RENAMED visit counter function ***
import { incrementAppVisitCount } from './utils/pwaUtils';


// --- BEGIN iOS Standalone Detection ---
// Check for iOS environment
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
// Check if running in standalone mode (launched from Home Screen)
const isStandalone = 'standalone' in window.navigator && window.navigator.standalone;

// If both conditions are true, add a class to the body
if (isIOS && isStandalone) {
  document.body.classList.add('ios-standalone');
  console.log('iOS Standalone mode detected. Added .ios-standalone class to body.');
}
// --- END iOS Standalone Detection ---

// --- BEGIN Service Worker Registration ---
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(error => {
        console.log('ServiceWorker registration failed: ', error);
      });

    // *** Increment visit count on page load using RENAMED function ***
    incrementAppVisitCount();

  });
} else {
   console.log('Service workers are not supported by this browser.');
}
// --- END Service Worker Registration ---


// Initialize the console log interceptor as early as possible
initializeLogInterceptor();

// Log initialization details
console.log('--- REACT APP INITIALIZING --- Path:', window.location.pathname);

// Find the root DOM element for mounting the React app
const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  // For development, we are removing React.StrictMode to avoid duplicate effect invocations
  // (which can cause the countdown component to mount/unmount and reset prematurely).
  // Once you’ve confirmed the fix, you can wrap <App /> in <React.StrictMode> again if desired.
  root.render(
    <App />
  );
} else {
  console.error("Failed to find the root element. Make sure your HTML file has an element with the ID 'root'.");
}